import Vue from 'vue';
import Vuex from 'vuex';

import company from './modules/company';
import app from './modules/app';
import campaign from './modules/campaign'

Vue.use(Vuex);

const state = {
   pageFilters: []
};


const mutations = {

   CREATE_PAGE_FILTERS(state, data) {
      let page = state.pageFilters.filter(pf => pf.page === data.page);

      if (!page || !page.length) {
         data.filters.map(f => {
            f.value = f.value || null;
            f.label = f.label || '';
            f.active = f.active || false;
         });
         state.pageFilters.push(data);
      }

   },

   UPDATE_PAGE_FILTER(state, data) {
      let page = state.pageFilters.filter(pf => pf.page === data.page);

      if (page && page.length) {
         let filter = page[0].filters.filter(f => f.field === data.field);

         if (filter && filter.length) {
            filter[0].value = data.value;
            filter[0].label = data.label || '';
            filter[0].active = [null, '', undefined].indexOf(data.value) === -1;

            // console.log('commited 1 filter: ', JSON.stringify(filter[0]));
         }
      }

   },

   UPDATE_ALL_PAGE_FILTERS(state, data) {
      let page = state.pageFilters.filter(pf => pf.page === data.page);

      if (page && page.length) {
         for (let i = 0; i < data.filters.length; i++) {
            let d = data.filters[i];
            let filter = page[0].filters.filter(f => f.field === d.field);

            if (filter && filter.length) {
               filter[0].value = d.value;
               filter[0].label = d.label || '';
               filter[0].active = [null, '', undefined].indexOf(d.value) === -1;

               // console.log('commited filter: ', JSON.stringify(filter[0]));

            }

         }

      }
   }

};


const actions = {
   createPageFilters: ({commit, getters}, data) => {
      data.page = getters.currentPage;
      commit('CREATE_PAGE_FILTERS', JSON.parse(JSON.stringify(data)));
   },

   updatePageFilter: ({commit, getters}, data) => {
      if (data) {
         data.page = getters.currentPage;
         commit('UPDATE_PAGE_FILTER', JSON.parse(JSON.stringify(data)));
      }
   },

   updateAllPageFilters: ({commit, getters}, filters) => {
      if (filters) {
         let page = getters.currentPage;
         commit('UPDATE_ALL_PAGE_FILTERS', JSON.parse(JSON.stringify({page, filters})));
      }
   }
};


const getters = {
   currentPage() {
      return window.getApp.$route.path.split('/:')[0].replace(/\//g, '_');
   },

   getFilters(state, getters) {
      let page = getters.currentPage;

      let pf = state.pageFilters.filter(f => f.page === page);
      if (pf && pf.length)
         return pf[0].filters;

      return null;
   },

   hasFilters(state, getters) {
      let page = getters.currentPage;
      let pf = state.pageFilters.filter(f => f.page === page);
      return (pf && pf.length);
   },

   hasStoreFilter(state, getters) {
      let f = getters.getFilters;
      if (f) {
         let sf = f.filter(f => f.field === 'storeId');
         return (sf && sf.length) ? sf[0] : null;
      }

      return null;
   },

   pageFilterLabels(state, getters) {
      let filters = getters.getFilters;
      let labels = [];

      if (filters) {
         filters.forEach(f => {
            if (f.active && f.label) {
               labels.push(new Object({field: f.field, text: f.label}));
            }
         });
      }

      // console.log('pageFilters/filterLabels changed: ', JSON.stringify(labels));

      return JSON.parse(JSON.stringify(labels));

   },

   activePageFilters(state, getters) {
      let filters = getters.getFilters;

      let obj = {};
      if (filters) {
         filters.forEach(f => {
            if (f.active) {
               obj[f.field] = f.value;
            }
         });
      }

      // console.log('pageFilters/filters changed');

      return JSON.parse(JSON.stringify(obj));

   }
};



const store = new Vuex.Store({
   modules: {
      app,
      company,
      campaign
   },

   state,
   mutations,
   actions,
   getters,

   strict: false //because of navDrawer toggle.  TODO: change navDrawer toggle to enable strict vuex mode.
});


Vue.prototype.$store = store;

export default store;




// WEBPACK FOOTER //
// ./src/store/index.js